import React, { useContext, useEffect } from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const orderNo = sessionStorage.getItem("checkoutOrderNo");

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [clearCart, isSuccess]);

  return (
    <div className={`payment-result ${isSuccess ? "is-success" : "is-cancel"}`}>
      <div className="payment-result__card">
        <div className="payment-result__icon" aria-hidden="true">
          <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
        </div>
        <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
        <p>
          {isSuccess
            ? "Thank you. Your order has been received and is being processed."
            : "Your payment was not completed. Your cart is still available if you would like to try again."}
        </p>
        {orderNo && (
          <p className="payment-result__order">Order number: {orderNo}</p>
        )}
        <div className="payment-result__actions">
          {isSuccess ? (
            <Link to="/shop">Continue shopping</Link>
          ) : (
            <Link to="/checkout">Return to checkout</Link>
          )}
          <Link className="secondary" to="/">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaySuccess;
